<template>
  <layout :title="title">
    <form-layout class="mx-auto">
      <form-wrapper @submit="submit()">
        <v-row class="form-row">
          <v-col cols="12" md="6">
            <input-field
              label="First Name"
              rules="required"
              name="first_name"
              v-model="form.first_name"
            ></input-field>
          </v-col>
          <v-col cols="12" md="6">
            <input-field
              label="Last Name"

              name="last_name"
              v-model="form.last_name"
            ></input-field>
          </v-col>
          <v-col cols="12" md="6">
            <input-field
              label="Email"
              name="email"
              v-model="form.email"
            ></input-field>
          </v-col>
        </v-row>
        <div class="d-flex">
          <v-spacer></v-spacer>
          <close-button
            :disabled="loading"
            :to="{ name: 'referrals' }"
          ></close-button>
          <secondary-button
            class="ml-3"
            :loading="loading"
            type="submit"
            >
            Submit
          </secondary-button>
        </div>
      </form-wrapper>
    </form-layout>
  </layout>
</template>

<script>
import Layout from "@/components/ui/Layout.vue";
import InputField from "@/components/ui/form/InputField.vue";
import CloseButton from "@/components/ui/buttons/CloseButton.vue";
import SecondaryButton from "@/components/ui/buttons/SecondaryButton.vue";
import FormWrapper from "@/components/ui/form/FormWrapper.vue";
import {colReferrals, functions} from "@/assets/utils/firebase.utils";
import {doc, getDoc, getDocs, limit, query, where} from "firebase/firestore";
import {httpsCallable} from "firebase/functions";
import FormLayout from "@/components/ui/FormLayout.vue";

export default {
  components: {
    Layout,
    InputField,
    CloseButton,
    SecondaryButton,
    FormWrapper,
    FormLayout,
  },
  data() {
    return {
      loading: false,
      isLoading: false,
      form: {
        first_name: "",
        last_name: "",
        email: "",
      },
    };
  },
  computed: {
    isUpdate() {
      return this.$route.params.id !== 'new';
    },
    title() {
      return this.isUpdate ? "Edit Referral" : "Add Referral";
    },
  },
  methods: {
    async submit() {
      try {
        this.loading = true;
        const data = { ...this.form };
        if (this.isUpdate) {
          const manageReferral = httpsCallable(functions, "manageReferral");
          await manageReferral({ action: "update", data: { ...data, id: this.$route.params.id } });
          this.notifySuccess("Referral updated successfully");
        } else {
          if (this.form.email) {
            const docsSnap = await getDocs(
              query(
                colReferrals,
                where("email", "==", this.form.email),
                limit(1)
              )
            );
            if (!docsSnap.empty) {
              this.notifyError("Referral with this email already exists");
              return;
            }
          }
          const manageReferral = httpsCallable(functions, "manageReferral");
          const result = await manageReferral({ action: "create", data });
          const newId = result.data.id;
          if (!newId) {
            this.notifyError("Failed to add referral");
          } else {
            this.notifySuccess("Referral added successfully");
            await this.$router.replace({name: "referral", params: {id: newId}});
          }
        }
      } catch (error) {
        this.handleError(error);
      } finally {
        this.loading = false;
      }
    },
    async fetchReferral() {
      try {
        this.isLoading = true;
        const docRef = doc(colReferrals, this.$route.params.id);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          this.form = { ...docSnap.data() };
        } else {
          this.notifyError("Referral not found");
          await this.$router.replace({name: "referrals"});
        }
      } catch (error) {
        this.handleError(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  mounted() {
    if (this.isUpdate) {
      this.fetchReferral();
    }
  },
};
</script>

<style></style>
